// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2XukD","upload":"Small_upload__1G8Y4","imageWrap":"Small_imageWrap__1UlGj","removeBtn":"Small_removeBtn__bzuf5"};